import React from 'react';
import { useSelector } from 'react-redux';
import { colors } from '@/globalStyles';
import { getShapeFill, createClassName } from '@/helpers';
import PrimitiveRenderer from '../../shared/PrimitiveRenderer';
import {
  SYSTEM_STROKE_WIDTH,
  systemStrokeWidthProps,
  WIZARD_STROKE_WIDTH,
  wizardStrokeWidthProps,
} from './styles';

const PageShieldRenderer = props => {
  const {
    isSelected,
    onShapeClick,
    isGridDisplayed,
    withMiddleLines,
    gridWidth,
    selRadius,
    shapeObj,
    useFineStrocke,
  } = props;
  const paperColor = useSelector(state => state.core.paperColor);
  const {
    primitiveType,
    primitiveProps,
    fillColor, // group color
    strokeColor,
    id,
  } = shapeObj;
  const shapeFill = getShapeFill({
    shapeRendererAdditProps: { paperColor },
    shapeObj,
    isSelected,
    isGridDisplayed,
  });
  const localStrokeWidth = useFineStrocke
    ? WIZARD_STROKE_WIDTH
    : SYSTEM_STROKE_WIDTH;
  const localSystemStrokeWidthProps = useFineStrocke
    ? wizardStrokeWidthProps
    : systemStrokeWidthProps;
  const clickable = true;
  const className = `shield ${createClassName({ clickable })}`;

  const handleFastClickTap = () => {
    onShapeClick(shapeObj);
  };

  return (
    <>
      <defs>
        <clipPath id={`${id}-clip-path`}>
          <rect
            x={primitiveProps.x + localStrokeWidth / 2}
            y={primitiveProps.y + localStrokeWidth / 2}
            width={primitiveProps.w - localStrokeWidth}
            height={primitiveProps.h - localStrokeWidth}
          />
        </clipPath>
        {isGridDisplayed && (
          <pattern
            id={`${id}-grid`}
            x={primitiveProps.x}
            y={primitiveProps.y}
            width={gridWidth}
            height={gridWidth}
            patternUnits="userSpaceOnUse"
          >
            <circle cx="0" cy="0" r={selRadius} />
            <circle cx={gridWidth} cy="0" r={selRadius} />
            <circle cx={gridWidth} cy={gridWidth} r={selRadius} />
            <circle cx="0" cy={gridWidth} r={selRadius} />
          </pattern>
        )}
      </defs>
      <PrimitiveRenderer
        style={{
          cursor: 'pointer',
          fill: shapeFill,
          stroke: strokeColor,
          ...localSystemStrokeWidthProps,
        }}
        className={className}
        id={id}
        primitiveType={primitiveType}
        primitiveProps={primitiveProps}
        clickable={clickable}
        onFastClickTap={handleFastClickTap}
        withMiddleLines={withMiddleLines}
        shapeObj={shapeObj}
      />
      {isSelected && (
        <rect
          style={{ pointerEvents: 'none' }}
          className="shield--selected"
          x={primitiveProps.x}
          y={primitiveProps.y}
          width={primitiveProps.w}
          height={primitiveProps.h}
          fill={colors.paternoster}
        />
      )}
    </>
  );
};

export default React.memo(PageShieldRenderer);
